import React, { useEffect, useRef } from 'react';
import * as Styled from './VHLogsAreaV2.styled';

/** @typedef { import('@vh/slices/chat/ChatSlice.types').ChatLogItem } ChatLogItem */

/**
 * @type {React.FC<{
 *  loadingBotResponse?: boolean;
 *  loadingUserRequest?: boolean;
 *  textChats: ChatLogItem[];
 *  emptyUserTextReplacement?: string;
 *  footer?: React.ReactNode;
 * }>}
 */
const VHLogsAreaV2 = ({
  loadingBotResponse,
  loadingUserRequest,
  textChats,
  emptyUserTextReplacement = '',
  footer,
}) => {
  const logsListRef = useRef(null);
  useEffect(() => {
    logsListRef.current.scrollTop =
      logsListRef.current.scrollHeight - logsListRef.current.offsetHeight;
  }, [textChats]);

  return (
    <Styled.LogsListWrapper>
      <Styled.LogsList ref={logsListRef}>
        {textChats.map((item, index) => (
          <React.Fragment key={item.id}>
            {item.loading && !item.text ? (
              <Styled.LoadingIndicator $chatType={item.chatType}>
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </Styled.LoadingIndicator>
            ) : (
              <Styled.ChatBubble $chatType={item.chatType}>
                {item.text || emptyUserTextReplacement}
              </Styled.ChatBubble>
            )}
          </React.Fragment>
        ))}
      </Styled.LogsList>
      {footer}
    </Styled.LogsListWrapper>
  );
};

export default VHLogsAreaV2;
